import { ApolloError } from "@apollo/client/core";
import { readable } from "svelte/store";
export function observableToReadable(observable, initialValue = {
    loading: true,
    data: undefined,
    error: undefined,
}) {
    return readable(initialValue, (set) => {
        const skipDuplicate = (initialValue === null || initialValue === void 0 ? void 0 : initialValue.data) !== undefined;
        let skipped = false;
        const subscription = observable.subscribe((result) => {
            if (skipDuplicate && !skipped) {
                skipped = true;
                return;
            }
            if (result.errors) {
                const error = new ApolloError({ graphQLErrors: result.errors });
                set({ loading: false, data: undefined, error });
            }
            else {
                set({ loading: false, data: result.data, error: undefined });
            }
        }, (error) => set({ loading: false, data: undefined, error }));
        return () => subscription.unsubscribe();
    });
}
export const extensions = [
    "fetchMore",
    "getCurrentResult",
    "getLastError",
    "getLastResult",
    "isDifferentFromLastResult",
    "refetch",
    "resetLastResults",
    "resetQueryStoreErrors",
    "result",
    "setOptions",
    "setVariables",
    "startPolling",
    "stopPolling",
    "subscribeToMore",
    "updateQuery",
];
export function observableQueryToReadable(query, initialValue) {
    const store = observableToReadable(query, initialValue);
    for (const extension of extensions) {
        store[extension] = query[extension].bind(query);
    }
    return store;
}
